import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const WHATSAPP_NUMBER = "919372533952";
export const PHONE_DISPLAY = "+91 93725 33952";
export const EMAIL = "clothingtoga@gmail.com";
export const ADDRESS =
  "Shop No 30, Chadda Crescent, Sector 17, Vashi, Navi Mumbai, Maharashtra 400703";
export const INSTAGRAM = "https://www.instagram.com/togamenswear";
export const FACEBOOK = "https://www.facebook.com/share/19FxTCbL9Y/";

export function whatsappLink(message) {
  const text = encodeURIComponent(message || "Hello TOGA, I'd like to inquire about your collection.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
